import React, { useEffect, useState } from "react";
import styles from "./HomeSliderCard.module.scss";
import placeholderImage from "../../../assets/Imagess/placeholder.jpg";
import InfoButton from "../../Atoms/InfoButton/InfoButton";
import moreInfo from "../../../assets/icons/programs/major/moreInfo.svg";
import editSvg from "../../../assets/icons/formActions/edit.svg";
import deleteSvg from "../../../assets/icons/formActions/delete.svg";
import DeletePopup from "../Custom/DeletePopup";
import { useDeleteSlider } from "../../../Hooks/HomeSlider";
import { useToast } from "../Custom/CustomToaster/Toast";
import { useNavigate } from "react-router-dom";

const HomeSliderCard = ({ item, refetch }) => {
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const navigate = useNavigate();
  const customizedToast = useToast();
  const {
    mutate: deleteSlider,
    isLoading: isDeletingSlider,
    isSuccess,
  } = useDeleteSlider(item?.id);

  useEffect(() => {
    if (isSuccess) {
      customizedToast.open("تم الحذف بنجاح");
    }
  }, [isSuccess]);

  useEffect(() => {
    refetch();
  }, [isDeletingSlider]);

  const menuItems = [
    {
      label: "تعديل",
      icon: editSvg,
      onClick: () => {
        navigate(`/home/edit-home-slider/${item?.id}`);
      },
    },
    {
      label: "حذف",
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];

  const mediaUrl = `${item?.blobUrl || ""}${item?.media1 || ""}`;

  const isVideo = /\.(mp4|webm|ogg|ogv|mov|m4v)$/i.test(mediaUrl);

  return (
    <div className={styles["slider-card"]}>
      {isVideo ? (
        <video
          className={styles["placeholder-img"]}
          src={mediaUrl}
          controls
          playsInline
        />
      ) : (
        <img className={styles["placeholder-img"]} src={mediaUrl} alt="" />
      )}
      <div className={styles["card-body"]}>
        <div className={styles["card-info"]}>
          <p className={styles["slide-number"]}>{item?.sequenceId}</p>
          <InfoButton
            icon={moreInfo}
            className={styles["more-info"]}
            data={menuItems}
            left
          />
        </div>
        <p className={styles["title"]}>{item?.title}</p>
        <div
          className={styles["sub-title"]}
          dangerouslySetInnerHTML={{
            __html: (() => {
              const t = document.createElement("textarea");
              t.innerHTML = item?.description || "";
              return t.value;
            })(),
          }}
        />
      </div>
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title="محتوى الصفحة الرئيسيةشريط"
          handleDelete={() => {
            deleteSlider();
            setShowDeletePopup(false);
          }}
          isLoading={isDeletingSlider}
        />
      )}
    </div>
  );
};

export default HomeSliderCard;
